export const LOCALE = {
  PL: "pl",
  EN: "en",
  ES: "es"
};
